var params = { 
  apiKey: 'LSIHpnLauev8XfVsg0RJ993BCEQuD1d11Q7LYaWW',
  popupIntegration: {
    centeredHorizontal: true,
    centeredVertical: true,
    width: '600px',
    height: '500px',
  },
};

window.fitmixInstance = FitMix.createWidget('my-fitmix-container', params);

/*
// Example 1: change position of popup
params.popupIntegration = {
  vertical: 'top',
  horizontal: 'left',
}
*/

/*
// Example 1: center popup
params.popupIntegration = {
  centeredVertical: true,
  centeredHorizontal: true,
}
*/